export default "__VITE_ASSET__YGj3HCI0__"